import { environment } from '@environment';

const basePackagesApi: string = environment.api.netactica;
const apiTravelProxyMs = `${environment.api.services}/api/travel-proxy-ms/package`;

export const packagesResultApi = {
  package_upsell_whole_trip: `${basePackagesApi}/Package/Upsell/WholeTrip/?SearchId={searchId}` + 
  '&optionIdAir={optionIdAir}&HotelRateId={rateId}&OptionIdHotel={hotelOptionId}' + 
  '&extendedInformation={extendedInformation}',
  // eslint-disable-next-line max-len
  package_hotel_detail: `${basePackagesApi}/Package/HotelDetails?SearchId={searchIdHotel}&OptionIdHotel={hotelOptionId}&OptionIdAir={optionIdAir}`,
  package_air_results: `${apiTravelProxyMs}/air/results`,
  package_by_hotel_code: `${basePackagesApi}/Package/SearchByHotelCode`,
  package_air_grouped_results: `${basePackagesApi}/Package/AirGroupedResultv2`,
  package_search: `${apiTravelProxyMs}/v2/search`,
  package_hotel_results: `${apiTravelProxyMs}/hotel/results`,
  air_filters: `${basePackagesApi}/Package/AirFilterV2`,
  hotel_filters: `${basePackagesApi}/Package/HotelFilterv2`,
  air_option: `${environment.api.netactica}/AirGroupedResults?searchId={searchId}`,
};
